import { useEffect, useState } from "react";

const navItems = [
  { label: "首页", href: "#home" },
  { label: "故事简介", href: "#story" },
  { label: "角色介绍", href: "#characters" },
  { label: "关系图谱", href: "#relationship" },
  { label: "CP感情线", href: "#romance" },
  { label: "热门内容", href: "#articles" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 shadow-[0_2px_20px_rgba(0,0,0,0.06)] backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav
        className={`mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6 ${
          scrolled ? "text-foreground-800" : "text-white"
        }`}
        aria-label="主导航"
      >
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
            <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide">
            恋爱辅助器<span className="text-primary-500">漫画站</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-full px-4 py-2 text-sm font-medium transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            联系我们
          </a>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-foreground-800 lg:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-center text-sm font-semibold text-white hover:bg-primary-600"
            >
              联系我们
            </a>
          </div>
        </div>
      )}
    </header>
  );
}